import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";

import { getAccountFeatureFlagListService } from "../api/getUserFeatureFlagListService";

type TUseGetAccountFeatureFlagListParameters = {
  queryEnabled: boolean;
  userId: string;
};

export const useGetAccountFeatureFlagList = ({ queryEnabled, userId }: TUseGetAccountFeatureFlagListParameters) =>
  useQuery({
    queryKey: [QUERY_KEYS.get_account_feature_flag_list],
    queryFn: () => getAccountFeatureFlagListService(userId),
    enabled: queryEnabled,
    staleTime: Infinity
  });
